import { render, staticRenderFns } from "./CommonDocsModal.vue?vue&type=template&id=c5eab064&"
import script from "./CommonDocsModal.vue?vue&type=script&lang=js&"
export * from "./CommonDocsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports